{
  "conflict": {
    "title": "Terminkonflikt erkannt",
    "defaultMessage": "Ein anderer Benutzer hat die Position dieses Flugzeugs geändert. Deine Änderungen könnten seine überschreiben.",
    "attemptProgress": "Versuch {{current}} von {{max}}",
    "retryExplanation": "• Erneut versuchen speichert deine Änderungen nochmals und überschreibt dabei möglicherweise die des anderen Nutzers.",
    "cancelExplanation": "• Abbrechen verwirft deine Änderungen und lädt den aktuellen Stand neu.",
    "cancelButton": "Änderungen verwerfen",
    "retryButton": "Neu speichern"
  },
  "confirmation": {
    "defaultCancel": "Abbrechen",
    "defaultOk": "OK",
    "typeToConfirm": "Gib delete ein, um das Löschen zu bestätigen.",
    "deletePlaceholder": "Löschen"
  },
  "progress": {
    "defaultItemName": "Punkt",
    "processing": "Verarbeite {{current}} von {{total}} {{itemName}}",
    "processingPlural": "Verarbeite {{current}} von {{total}} {{itemName}}s",
    "currentLabel": "Aktuell: {{currentItem}}"
  },
  "error": {
    "defaultTitle": "Hoppla! Da ist etwas schiefgelaufen",
    "defaultDescription": "Ein unerwarteter Fehler ist aufgetreten.",
    "teamNotified": "Das AirPlx-Team wurde benachrichtigt und kümmert sich darum.",
    "errorDetailsLabel": "Fehlerdetails (nur für Entwickler):",
    "componentStackLabel": "Komponentenstapel",
    "refreshButton": "Neu laden",
    "returnHome": "Zur Startseite"
  },
  "notes": {
    "title": "Flugzeugnotizen",
    "label": "Notizen",
    "placeholder": "Abflugzeit: 24.05.2025 12:00",
    "lastUpdate": "Letzte Aktualisierung: {{time}} ({{date}}) von {{user}}",
    "cancelButton": "Abbrechen",
    "saveButton": "Speichern"
  }
}
